import { ConversationDto } from './conversation.dto';
import {ConversationStreamInterface} from "../../..";

export class ConversationsStreamDto implements ConversationStreamInterface {
  userUnreadMessagesCount?: number;
  conversations?: ConversationDto[];
}
